import { useContext, useMemo } from "react";

import RangeSlider from "@stadium/ui/src/components/RangeSlider";

import {
  INIT_PRICE_RANGE_IDS,
  ProductListingContext,
} from "@components/store/products/listing/listing-provider";

import CheckboxInput from "@stadium/ui/src/components/form/CheckboxInput";
import FormLabel from "@sharedComponents/form-label";

import styles from "./main.module.scss";

const emptyArr = [];

/**
 * Sidebar price filter: live `onChange` updates listing; analytics fire on gesture end /
 * checkbox / committed min-max inputs via `onAfterChange`, `onCommit`, `onInputCommit`.
 */
const PriceRangeSlider = ({
  items,
  onChange,
  onBeforeChange,
  onAfterChange,
  onCommit,
  selectedIds,
  isFetchingProducts,
}) => {
  const { isPriceRangeFilterEnabled, setIsPriceRangeFilterEnabled } =
    useContext(ProductListingContext);

  const { min = 0, max = 0, step, currencySymbol } = items;

  const onChangeCheckbox = () => {
    const baseline = Array.isArray(selectedIds) ? [...selectedIds] : [...INIT_PRICE_RANGE_IDS];
    if (isPriceRangeFilterEnabled) {
      onChange(emptyArr);
      onCommit?.(emptyArr, baseline);
      return;
    }
    onChange([min, max]);
    setIsPriceRangeFilterEnabled(true);
    onCommit?.([min, max], baseline);
  };

  const value = useMemo(
    () => (selectedIds === INIT_PRICE_RANGE_IDS ? [min, max] : selectedIds),
    [min, max, selectedIds],
  );

  return (
    <div className={styles.checkListCont}>
      <CheckboxInput
        disabled={isFetchingProducts}
        checked={isPriceRangeFilterEnabled}
        onChange={onChangeCheckbox}
        label={<FormLabel iconType="check">Select Range ({currencySymbol})</FormLabel>}
        className={styles.checkboxInput}
        classes={styles.checkListItem}
        name="price-range-toggle"
        id="price-range-toggle"
      />
      <RangeSlider
        key={`${max}-max-value:${min}-min-value:${isPriceRangeFilterEnabled}`}
        disabled={isFetchingProducts || !isPriceRangeFilterEnabled}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        onBeforeChange={onBeforeChange}
        onAfterChange={onAfterChange}
        onInputCommit={(next, prev) => onCommit?.(next, prev)}
        step={step}
        className={styles.rangeSlider}
      />
    </div>
  );
};

export default PriceRangeSlider;
